import script from "./detailDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./detailDialog.vue?vue&type=script&lang=ts&setup=true"

import "./detailDialog.vue?vue&type=style&index=0&id=bf8382f8&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf8382f8"]])

export default __exports__